<div *ngIf="showQuestionsAndAnswer" id="pdp-question-answers" class="questions-and-answers-content" [ngClass]="{ 'show-questions-and-answers hmf-mb-l hmf-mb-m-xl': showQuestionsAndAnswer }">
  <common-accordion [isCollapsed]="isCollapsed" [hideHeading]="true" [isDisabled]="!isQandACountPresent" (accordionClicked)="setIsCollapsed($event)">
      <h2 class="questions-and-answers-header hmf-flex-grow" myPanelHeader [ngClass]="{'pointer': isQandACountPresent}">Product Q&amp;A</h2>
      <div class="questions-and-answers-header-secondary hmf-flex-grow" myPanelHeaderSecondary [ngClass]="{'hide-content': !isCollapsed}">
          <div *ngIf="isQandACountPresent" class="questions-and-answers-header-secondary-content">
              <div class="snack-bar">
                Questions
              </div>
              <button (click)="askAQuestion($event)" class="ask-question-btn">Ask A Question</button>
          </div>
      </div>
      <div class="panel-content questions-and-answers-body" myPanelBody id="QA-body" [ngClass]="{'hide-body': isCollapsed}">
          <div data-bv-show="questions" [attr.data-bv-product-id]="productIdentifier">
            <div id="bv-seo-questions" class="hidden" *ngIf="seoQuestions">
              <span [innerHTML]="seoQuestions | dcsgSanitizeHtml"></span>
            </div>
            <div id="ratings-progress-spinner" class="ratings-progress-spinner">
              <common-progress-spinner [diameter]="40" [strokeWidth]="4"></common-progress-spinner>
            </div>
          </div>
        </div>
  </common-accordion>
</div>
